<template>
    <div class="float-left mr-1">
        <b-button
            variant="success"
            @click.stop="abrirFecharModal()"
            class="mr-2">
            <i class="fa fa-edit"></i> Alterar Dias para Correção
        </b-button>
        <b-modal v-model="exibirModal" :hide-footer="false" @show="preencherFormulario()">
            <div slot="modal-title">
                Alterar Dias para Correção -
                <b-badge variant="warning">{{ operacao }}</b-badge>
            </div>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Dias para correção</label>
                        <b-input-group>
                            <b-form-input
                                type="number"
                                v-model="quantidadeDiasParaCorrecao"
                                :max="9999"
                                 @input.native="limitarCaracteres"
                                :state="$v.quantidadeDiasParaCorrecao.$error ? false : null"                                
                            ></b-form-input>
                            <b-form-invalid-feedback>O campo é obrigatório e deve ser maior que zero.</b-form-invalid-feedback>
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button variant="secondary" @click.stop="cancelar()"
                    >Cancelar</b-button
                >
                <b-button
                    variant="primary"
                    :disabled="desabilitarBtnSalvar"
                    @click.stop="atualizarDiasParaCorrecao()"
                    class="ml-1"
                    >Salvar</b-button
                >
            </div>
        </b-modal>
    </div>
</template>

<script>
import FiscalizacoesServicos from '../FiscalizacoesServicos'
import { required, minValue } from 'vuelidate/lib/validators'

export default {
    props: {
        irregularidadeFiscalizacao: {
            type: Object,
            required: true
        },
    },

    data() {
        return {
            exibirModal: false,
            operacao: 'ALTERAR',
            quantidadeDiasParaCorrecao: '',
            erros: [],
        }
    },

    methods: {
        atualizarDiasParaCorrecao() {
            this.$store.dispatch('addRequest')
            FiscalizacoesServicos
            .alterarDiasParaCorrecaoIrregularidade(this.irregularidadeFiscalizacao.idIrregularidadeFiscalizacao, this.quantidadeDiasParaCorrecao)
            .then(response => {
                if (response) {
                    if (response.success) {
                        this.registroSalvoComSucesso()
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        limitarCaracteres(event) {
            let valor = event.target.value
            if (valor < 0) {
                valor = 1
            }

            if (valor.length > 4) {
                valor = valor.slice(0, 4)
                event.target.value = valor
            }
            this.quantidadeDiasParaCorrecao = valor
        },

        abrirFecharModal() {
            this.exibirModal = !this.exibirModal
        },

        preencherFormulario() {
            this.quantidadeDiasParaCorrecao = this.irregularidadeFiscalizacao.diasParaCorrecao
        },

        cancelar() {
            this.abrirFecharModal()
            this.resetForm()
        },

        resetForm() {
            this.quantidadeDiasParaCorrecao = ''
            this.erros = []
            this.$nextTick(() => {
                this.$v.$reset()
            })
        },

        registroSalvoComSucesso() {
            this.$toast.success('Registro alterado com sucesso!', 'OK', this.$toastConfig.success)
            this.$emit('onAtualizarDiasParaCorrecao')
            this.cancelar();
        }
    },

    computed: {
        desabilitarBtnSalvar() {
            return this.$v.$invalid
        },
    },

    watch: {},

    validations: {
        quantidadeDiasParaCorrecao: {
            required, 
            minValue: minValue(1)
        }
    }
}
</script>